import React from "react";

//used to try to get powr.io plugins to work.
const XHRScript = `
<script>
(function (xhr) {
  const pt = xhr.prototype;
  pt._open = pt.open;
  pt.open = function () {
    const { href } = window.top.location;
    const winLoc = href.substring(0, href.length - 1);
    const { protocol, host } = document.location;
    const loc = encodeURIComponent(\`\${protocol}//\${host}\`);
    const url = arguments[1];
    if (url) {
      arguments[1] = url.replace(loc, encodeURIComponent(winLoc));
    }
    this._open.apply(this, arguments);
  };
})(XMLHttpRequest)
</script>
`;

const IFrameStyle = (height) =>
  `<style>iframe{display:block;width:100% !important;height:${height}px !important;} body, html{margin: 0; padding: 0; height: 100%;}</style>`;

const CrossDomainFrame = ({ src, code, height }) => {
  const useScript = !!localStorage.getItem("powrIOFix");
  const frameProps = {
    width: "100%",
    frameBorder: "0",
    allowFullScreen: 1,
    sandbox: "allow-scripts allow-presentation allow-same-origin",
    ...(code ? { display: "block", height: height } : { height: "100%" }),
  };

  if (code) {
    const iframecode = `<html>
        <head>
          ${IFrameStyle(height)}
          ${useScript ? XHRScript : ""}
        </head>
        <body>
          <div style="height:${height}px">${code}</div>
        </body>
      </html>
    `;

    frameProps.srcDoc = iframecode;
  } else {
    frameProps.src = src;
  }
  try {
    return <iframe {...frameProps} />;
  } catch (e) {}
};

export default CrossDomainFrame;
